module.exports = __webpack_public_path__ + "static/media/temp-w-domu-ok.3dc649cc.svg";